





































import { Component, Vue, Watch } from "vue-property-decorator";

import { User } from "../interfaces/user";

@Component
export default class NavigationList extends Vue {
    model: number = 0;
    public get items(): {
        icon: string;
        title: string;
        link: string;
        permission: boolean;
    }[] {
        return [
            {
                icon: "mdi-home",
                title: this.$t("navigation.home") as string,
                link: "/",
                permission: true,
            },
            {
                icon: "mdi-collage",
                title: this.$t("navigation.studios") as string,
                link: "/studios",
                permission: true,
            },
            {
                icon: "mdi-film",
                title: this.$t("navigation.script") as string,
                link: "/script",
                permission: true,
            },
            {
                icon: "mdi-chart-box",
                title: this.$t("navigation.reports") as string,
                link: "/reports",
                permission: true,
            },
            {
                icon: "mdi-calendar",
                title: this.$t("navigation.events") as string,
                link: "/events",
                permission: this.checkPermission("eventplanner"),
            },
        ];
    }

    public get user(): User | null {
        return this.$store.state.user;
    }

    public get availableItems() {
        return this.items.filter(i => i.permission);
    }
    @Watch("$store.state.user")
    public checkPermission(role: string): boolean {
        if (this.user && this.user.permissions) {
            return this.user.permissions.includes(role);
        }
        return false;
    }
}
